import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Methods } from "../../../Constants/ApiConstants";
import { EndPoints } from "../../../Constants/endpoints";
import { useGetData } from "../../../hooks";
import usePostData from "../../../hooks/ReactQuery/usePostData";
import { setMedicalTemplate } from "../../../redux/reducers/medicalRecordSlice";
import { RootState } from "../../../redux/store";
import { buildDefaultValues } from "../utils";
import { MedicalFields, MedicalKeys } from "../../../enums/MedicalReportEnums";

interface useMedicalTemplateDataProps {
  saveTemporaryAndContinue: boolean;
  setLocalSteps: any;
  methods: any;
}
export const useMedicalTemplateData = ({
  saveTemporaryAndContinue,
  setLocalSteps,
  methods,
}: useMedicalTemplateDataProps) => {
  const { type, templateId } = useParams();

  const dispatch = useDispatch();
  const isCustomizeMode = type === "customize";

  const medicalRecordTemplate = useSelector(
    (state: RootState) => state.medicalRecord.template,
  );

  const UpdateMedicalTemplateMutation = usePostData(
    `${EndPoints.UpdateMedicalHistory}/${templateId}`,
    Methods.PUT,
  );

  const getMedicalTemplateQuery = useGetData<any>(
    EndPoints.MedicalHistoryTypes,
    { enabled: !!templateId },
    templateId,
  );

  const selectedTemplate = saveTemporaryAndContinue
    ? medicalRecordTemplate
    : getMedicalTemplateQuery?.data?.Data;

  const onlyVisibleData = {
    ...selectedTemplate,
    Steps: selectedTemplate?.Steps?.filter((item: any) => item?.IsVisible),
  };
  const templateSteps = isCustomizeMode ? selectedTemplate : onlyVisibleData;

  const isDefaultTemplate = !getMedicalTemplateQuery?.data?.Data?.AccountId;

  const totalVisibleKeys: string[] = [];

  const collectStepFields = (fields?: any[], forceAttributesKey = false) => {
    if (!fields) return;

    fields.forEach((field) => {
      if (!field.IsVisible) return;
      const isLMP = field?.Key === MedicalKeys.LMP
      const isRepeater = field.Type === MedicalFields.Repeater;
      const useAttributesKey = forceAttributesKey || isRepeater || isLMP;

      totalVisibleKeys.push(
        useAttributesKey
          ? `Attributes.${field.Id}`
          : field.Key ?? `Attributes.${field.Id}`
      );

      collectStepFields(field.InverseParentStepFields, useAttributesKey);
    });
  };

  const collectSteps = (steps?: any[]) => {
    if (!steps) return;

    steps.forEach((step) => {
      collectStepFields(step.StepFields);
      collectSteps(step.InverseParentSteps);
    });
  };

  collectSteps(onlyVisibleData.Steps);

  useEffect(() => {
    //first init mediacal template
    if (getMedicalTemplateQuery.isSuccess) {
      dispatch(setMedicalTemplate(selectedTemplate));
      // methods?.reset({
      //   MedicalHistoryDate: moment().locale("en").format("DD-MM-YYYY"),
      //   ...methods.getValues(),
      // });
      if (isCustomizeMode) {
        methods?.reset({
          ...buildDefaultValues(selectedTemplate),
        });
      }
    }
  }, [getMedicalTemplateQuery.isSuccess, templateId, isCustomizeMode]);

  useEffect(() => {
    if (selectedTemplate) {
      setLocalSteps(templateSteps?.Steps || []);
    }
  }, [getMedicalTemplateQuery.isSuccess, selectedTemplate, isCustomizeMode]);

  return {
    isDefaultTemplate,
    getMedicalTemplateQuery,
    UpdateMedicalTemplateMutation,
    selectedTemplate,
    totalVisibleKeys
  };
};
